import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { galleryPhotos } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
export function Gallery() {
  const {
    t
  } = useLanguage();
  const reduceMotion = useReducedMotion();
  const track = [...galleryPhotos, ...galleryPhotos];
  return <section id="galeria" className="w-full overflow-hidden bg-ink py-20 lg:py-28" data-id="element-158" data-mp="3ddo4oyqmbwz0">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-159" data-mp="2polozwfjoe75">
        <div className="max-w-2xl" data-id="element-160" data-mp="2koha2auabrj1">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-161" data-mp="2kpii06g07xwj">{t.gallery.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-162" data-mp="2zeez0t01gl9a">
            {t.gallery.title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-cream/75 lg:text-lg" data-id="element-163" data-mp="26wsxy7k1d322">
            {t.gallery.intro}
          </p>
        </div>
      </div>

      <div className="relative mt-12" role="region" aria-label={t.gallery.regionLabel} data-id="element-164" data-mp="21xg8df1s5hvs">
        <motion.ul className="flex w-max gap-5 px-5 lg:px-8" animate={reduceMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={{
        duration: 38,
        ease: 'linear',
        repeat: Infinity
      }} style={{
        willChange: 'transform'
      }} data-id="element-165" data-mp="rbrst0v0cl6v">
          {track.map((src, index) => {
          const info = t.gallery.photos[index % galleryPhotos.length];
          const duplicate = index >= galleryPhotos.length;
          return <li key={`${src}-${index}`} aria-hidden={duplicate} className="relative w-[260px] shrink-0 overflow-hidden rounded-sm border border-white/10 sm:w-[340px] lg:w-[420px]" data-id="element-166" data-mp="dc9zq9aoilrp" data-mpi={index}>
                <img src={src} alt={duplicate ? '' : info.alt} loading="lazy" className="h-[300px] w-full bg-black object-cover sm:h-[380px] lg:h-[440px]" data-id="element-167" data-mp="merkskell8d4" />
                <div className="absolute inset-x-0 bottom-0 bg-ink/85 px-4 py-3" data-id="element-168" data-mp="3tvi25nfe5u9q">
                  <p className="font-display text-sm uppercase tracking-wider text-gold" data-id="element-169" data-mp="3pu6j60r0w7ai">
                    {info.caption}
                  </p>
                </div>
              </li>;
        })}
        </motion.ul>
      </div>
    </section>;
}